import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatKg(value: number) {
  if (value < 1000) {
    return value;
  }
  return value / 1000;
}

export function kgSuffix(value: number) {
  if (value < 1000) {
    return "kg";
  }
  return "t";
}

export const randomId = () => Math.random().toString(36).substring(2, 15);

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isDateToday = (date: Date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

type ConditionalWrapperProps = {
  condition: boolean;
  wrapper: (children: JSX.Element) => JSX.Element;
  children: JSX.Element;
};

export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps) => (condition ? wrapper(children) : children);

export const deepEqual = (object1: any, object2: any): boolean => {
  if (object1 === object2) {
    return true;
  }

  if (
    typeof object1 !== "object" ||
    typeof object2 !== "object" ||
    object1 == null ||
    object2 == null
  ) {
    return false;
  }

  const keys1 = Object.keys(object1) as any[];
  const keys2 = Object.keys(object2) as any[];

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];

    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1 as any, val2 as any)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

export const isObject = (object: any): boolean => {
  return object != null && typeof object === "object";
};


export const capitalizeAndReplace = (str: string): string => {
  const KNOWN_ACRONYMS = ["VRF", "PTAC", "WSHP", "AQ", "DAC"];

  const words = (str || '').toLowerCase().replace(/_/g, ' ').split(' ');

  return words
    .map(word =>
      KNOWN_ACRONYMS.includes(word.toUpperCase())
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
};
